import { 
    getCenteredCoordinateForAnimation, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    line,
    LINE_ANIMATION_TIME,
    getTimeByLayers
 } from '../../initials';

export class LineBottomLeftCenter {
        constructor({
            fromRowIndex,
            fromDotIndex,
            toRowIndex,
            toDotIndex,
            dots,
        }) {
            this.fromRowIndex = fromRowIndex;
            this.fromDotIndex = fromDotIndex;
            this.toRowIndex = toRowIndex;
            this.toDotIndex = toDotIndex;
            this.dots = dots;
    
        }

        static getAnimationSettings() {
            return {
                avaiableForMultipleLevels: true,
                type: 'LineBottomLeftCenter',
                fromBallPositionByDot: BallPositionByDot.BOTTOM_LEFT,
                toBallPositionByDot: BallPositionByDot.CENTER,
            };
        }

        getAnimationTime() {
           return getTimeByLayers(this.toRowIndex, this.fromRowIndex, LINE_ANIMATION_TIME);
        }
    
        animate(time) {    
            const fullTime = this.getAnimationTime();
            const t = time / fullTime;

            const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
            const endDot = this.dots[this.toRowIndex][this.toDotIndex];

            const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, 5 * Math.PI / 4);
            const endXY = getCenteredCoordinateForAnimation(endDot.dotX, endDot.dotY);

            return {
                x: line(
                    startXY.x, 
                    endXY.x, 
                    t,
                ),
                y: line(
                    startXY.y, 
                    endXY.y, 
                    t,
                ),
            };

        }
}